// Phone bottom bar (<768, owner addition A): the first five rail entries +
// «المزيد» (a sheet with the rest). 48 px targets. The active module's own
// menu rows show as a chip strip under the top bar (ModuleMenu variant strip).

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Ellipsis } from 'lucide-react';
import { useT } from './erp-context';
import { labelOf, splitForBottomBar, type RailEntry } from './gates';
import type { RailGroup } from './module-types';

export function BottomBar({ rail, active }: { rail: RailEntry[]; active: RailGroup | null }) {
  const t = useT();
  const [moreOpen, setMoreOpen] = useState(false);
  const { primary, more } = splitForBottomBar(rail);
  const moreActive = more.some((e) => e.group === active);
  return (
    <>
      <nav className="e-bottombar" aria-label="الوحدات" data-testid="bottom-bar">
        {primary.map((e) => {
          const Icon = e.icon;
          return (
            <Link key={e.group} to={e.to} className="e-rail-item" aria-current={e.group === active ? 'page' : undefined} data-testid={`bottom-${e.group}`}>
              <Icon aria-hidden="true" />
              <span className="e-rail-label">{labelOf(e, t)}</span>
            </Link>
          );
        })}
        {more.length > 0 && (
          <button
            type="button"
            className="e-rail-item"
            aria-current={moreActive ? 'page' : undefined}
            aria-expanded={moreOpen}
            data-testid="bottom-more"
            onClick={() => setMoreOpen((o) => !o)}
          >
            <Ellipsis aria-hidden="true" />
            <span className="e-rail-label">المزيد</span>
          </button>
        )}
      </nav>
      {moreOpen && (
        <div className="e-dialog-scrim" onClick={() => setMoreOpen(false)} data-testid="more-sheet">
          <div className="e-dialog" role="dialog" aria-label="المزيد" onClick={(ev) => ev.stopPropagation()}>
            <div className="e-menu-items">
              {more.map((e) => {
                const Icon = e.icon;
                return (
                  <Link key={e.group} to={e.to} className="e-menu-item" style={{ gap: 10, minHeight: 48 }} onClick={() => setMoreOpen(false)}>
                    <Icon aria-hidden="true" width={20} height={20} />
                    {labelOf(e, t)}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
